import { Progress } from 'antd'
import Flex from 'components/Flex'
import {
  AdjustIcon,
  SmallCirlcle,
  SpanText,
  StyledCardDiv,
  StyledDelete,
  StyledH2,
  StyledImg,
  StyledP,
  VisibleDiv,
} from 'components/Uploader/Styles'
import DeleteIcon from 'components/icons/Delete'
import Visibility from 'components/icons/Visibility'
import JPGIcon from 'components/icons/JPGIcon'
import PDFIcon from 'components/icons/PDFIcon'
import { deleteFile } from 'modules/Drive/actions'
import moment from 'moment'
import React from 'react'
import { useDispatch } from 'react-redux'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import XlsxIcon from '../icons/XlsxIcon'

const FileReader = ({
  file,
  setFile,
  isDummyFile = false,
  setIsUploaded,
  isLoader = false,
  progress,
  failed,
  handleRemoveClick,
}) => {
  const dispatch = new useDispatch()
  let size = (file.size / 1024 / 1024).toFixed(2) + ' MB'
  
  const viewFile = () => {
    const newWindow = window.open(file?.url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }
  const handleRemove = async () => {
    if (setIsUploaded) {
      setIsUploaded(false)
    }
    if (isDummyFile) {
      setFile(null)
      return SuccessMessage('File deleted successfully!')
    }
    let response = await dispatch(deleteFile(file?.url))
    if (response) {
      setFile(null)
      return SuccessMessage('File deleted successfully!')
    } else {
      return ErrorMessage('Failed to delete the file!')
    }
  }
  return (
    <StyledCardDiv center alignCenter>
      <StyledImg>
        <AdjustIcon margin>
          {file?.type === 'pdf' ? (
            <PDFIcon />
          ) : file?.type == 'xlsx' ? (
            <XlsxIcon />
          ) : (
            <JPGIcon />
          )}
        </AdjustIcon>
        <Flex column>
          <StyledH2>{file?.name}</StyledH2>
          {}{' '}
          {isLoader && progress < 100 && !failed ? (
            <Progress percent={progress} size="small" />
          ) : (
            <StyledP alignCenter>
              <SpanText>
                {moment(file?.date)?.format('Do MMM, YYYY') +
                  ' at ' +
                  moment(file?.date)?.format('h:mm')}
              </SpanText>
              <SmallCirlcle />
              <SpanText>{size}</SpanText>
              <SpanText> ({progress}% Done)</SpanText>
            </StyledP>
          )}
        </Flex>
      </StyledImg>

      <Flex alignCenter>
        <VisibleDiv onClick={() => viewFile()}>
          <Visibility />
        </VisibleDiv>
        <StyledDelete
          onClick={() =>
            handleRemoveClick ? handleRemoveClick() : handleRemove()
          }
        >
          <DeleteIcon />
        </StyledDelete>
      </Flex>
    </StyledCardDiv>
  )
}

export default FileReader
